/** Create once when a user starts an action; retain with its original draft on retry.
 * If a draft is persisted across reload, persist this ID with it. Identical payloads
 * from separate actions must never share an ID. The server validates the UUID.
 */
export function createRequestOperationIntent(): string {
    return crypto.randomUUID();
}

/** A replay can return HTTP 2xx with an unresolved/business-error outcome. */
export function assertRequestOperationSucceeded(response: Response, body?: any): void {
    const outcome = response.headers.get('X-Operation-Status') || '';
    if (['RETURNED_ERROR', 'NEEDS_REVIEW'].includes(outcome) || body?.success === false) {
        throw new Error(body?.message || body?.error || 'תוצאת הפעולה טרם אושרה. יש לבדוק לפני ניסיון נוסף');
    }
}
